import $ from 'jquery';

$(function() {
    $("#cancelOrderButton").on('click', function (e) {
        if (!confirm("Are you sure you want to cancel the order?")) {
            e.preventDefault();
        }
    });

    $("#deleteOrderButton").on('click', function (e) {
        if (!confirm("Are you sure you want to DELETE the order?")) {
            e.preventDefault();
        }
    });
});